import { css, unsafeCSS } from 'lit';

const outlinedLeft = new URL('assets/outlined-ribbon-left-edge.svg', import.meta.url).href;
const outlinedRight = new URL('assets/outlined-ribbon-right-edge.svg', import.meta.url).href;
const outlinedCenter = new URL('assets/outlined-ribbon-center.svg', import.meta.url).href;
const solidLeft = new URL('assets/solid-ribbon-left.svg', import.meta.url).href;
const solidRight = new URL('assets/solid-ribbon-right.svg', import.meta.url).href;

export const style = css`
  :host {
    display: block;
  }

  p {
    margin: 0;
  }

  .header {
    display: flex;
    justify-content: space-between;
  }

  .outlined-ribbon {
    background-image: url(${unsafeCSS(outlinedLeft)}), url(${unsafeCSS(outlinedRight)}), url(${unsafeCSS(outlinedCenter)});
    background-position: left 0, right 0, center 0;
    background-repeat: no-repeat, no-repeat, repeat-x;
    color: #25810e;
    display: block;
    font-size: 14px;
    height: 18px;
    left: 20px;
    padding: 4px 10px 4px 12px;
    position: relative;
    white-space: nowrap;
  }

  .ribbon-text {
    position: relative;
    top: -1px;
  }

  .solid-ribbon {
    background-image: url(${unsafeCSS(solidLeft)}), url(${unsafeCSS(solidRight)});
    background-position: left 0, right 0;
    background-repeat: no-repeat, no-repeat;
    color: white;
    display: block;
    font-size: 14px;
    height: 18px;
    left: 20px;
    padding: 4px 10px 4px 12px;
    position: relative;
    white-space: nowrap;
  }
`;
